"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _index = require("../../helpers/index.js");

var _excluded = ["name", "type", "URL"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var stringField = _index.formatters.stringField;

var getDefaultTemplate = function getDefaultTemplate(_ref) {
  var name = _ref.name,
      type = _ref.type,
      URL = _ref.URL,
      rest = _objectWithoutProperties(_ref, _excluded);

  return [{
    name: stringField(name),
    type: type || 'other',
    URL: URL || window.location.href
  }, rest];
};

var _default = getDefaultTemplate;
exports["default"] = _default;